module.exports = __webpack_public_path__ + "img/check-stock.a78852d7.svg";